import { Container, Row, Col, Button, Form } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import { get, post } from '../../../services/back.service';
import { uploadWithSignedUrl } from '../../../utils/uploadSignedUrl';
import useAutosave from '../../../hooks/useAutosave';

const FormTechPicture = ({ id }) => {
  const [bodyImages, setbodyImages] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const autosave = useAutosave(async () => {
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    await post('/peritaje/modifyinspection/pictures/' + id, {
      type: 'SO',
      images
    });
  });

  const updateImages = (name, value) => {
    const tmImages = bodyImages;
    const index = tmImages.findIndex((e) => e.name === name);
    if (index >= 0) {
      tmImages[index] = { ...value, name };
    } else {
      tmImages.push({ ...value, name });
    }
    setbodyImages([...tmImages])
    autosave.schedule();
  };

  const getCurrentImage = (name) => {
    const image = bodyImages.find((e) => e.name === name);
    if (image) {
      return image.base64
    } else {
      return ''
    }
  }

  const deleteImage = async (name) => {
    autosave.cancel();
    setbodyImages((prev) => prev.filter((e) => (e.name || e.original_name) !== name));
    const input = document.getElementById(name);
    if (input) input.value = null;
    await get(`/peritaje/deleteimage/${id}`, {}, { 'type': 'SO', 'name': name });
  };

  const showConvertImage = async (e, name) => {
    const currentFile = e.target.files[0];
    try {
      const metadata = await uploadWithSignedUrl(currentFile, id, 'SO', 'images', name);
      const preview = URL.createObjectURL(currentFile);
      updateImages(name, { ...metadata, name, base64: preview });
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    let respo;
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    const body = {
      type: 'SO',
      images
    };

    respo = await post('/peritaje/modifyinspection/pictures/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    };
  }

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/downloadimages/SO/' + id, {});
      if (respo.success) {
        setbodyImages(respo.data);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Imagen SOAT</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col>
          <div>
            <div>
              <img
                alt="sin imagen"
                width={'250px'}
                src={getCurrentImage('ImageSoat')}
              />
              <br />
              {getCurrentImage('ImageSoat') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('ImageSoat')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="ImageSoat"
                name="ImageSoat"
                onChange={(e) => { showConvertImage(e, 'ImageSoat'); }}
              />
            </Form.Group>
          </div>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FormTechPicture;
